module.exports = __webpack_public_path__ + "static/media/badAnswer.0ebe1c8f.png";